import cn from 'classnames';
import Cookies from '@ictlife/core/config/cookies';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';

import Login from '../../components/authentication/Login';

import { fetchUserBusinesses } from '../../state/actions/loginAction';

export const setAndReturnActiveMerchant = userBusinessList => {
  const activeMerchant = userBusinessList[0];
  localStorage.removeItem('addBusiness');
  return activeMerchant;
};

export const successFullyFetchedUserBusinesses = (
  userBusinessList,
  dispatch,
  router
) => {
  if (Cookies.get('ictl_token')) {
    dispatch({ type: 'CLEAR_BUSINESS_LIST_MESSAGES' });
    if (
      Cookies.get('ictl_user') &&
      JSON.parse(Cookies.get('ictl_user')).first_name
    ) {
      if (userBusinessList?.length > 0) {
        const activeMerchant = setAndReturnActiveMerchant(userBusinessList);
        router.push(`/business/${activeMerchant.merchant.business_username}`);
      } else {
        router.push('/business/register');
      }
    } else {
      router.push('/user/info');
    }
  }
};

export default function LoginContainer() {
  const router = useRouter();
  const dispatch = useDispatch();

  const loginCallback = () => {
    if (
      localStorage.activeMerchant &&
      JSON.parse(Cookies.get('ictl_user')).id ===
        JSON.parse(localStorage.activeMerchant).merchant.user_id
    ) {
      const activeMerchant = JSON.parse(localStorage.activeMerchant);
      router.replace(`/business/${activeMerchant.merchant.business_username}`);
    } else {
      localStorage.activeMerchant && localStorage.removeItem('activeMerchant');
      fetchUserBusinesses(dispatch).then(userBusinessList =>
        successFullyFetchedUserBusinesses(userBusinessList, dispatch, router)
      );
    }
  };
  return (
    <Login
      appName="Merchant"
      AppLink={AppLink}
      loginCallback={loginCallback}
      appInstructions={styles => <AppInstructions styles={styles} />}
    />
  );
}

const AppInstructions = ({ styles }) => (
  <div className={styles.qrcodeSteps}>
    <div className={cn(styles.compTitle, 'theme-text')}>ICTLIFE</div>
    <span className={styles.qrCodeHeader}>Merchant App</span>
    <div className={styles.title}>Instructions</div>
    <div className={styles.steps}>
      <div>
        1. Open <b>settings</b> on the ICTLIFE Merchant App
      </div>
      <div>
        2. Tap <b>Sessions</b>
      </div>
      <div>
        3. Tap <b>Scan QR Code to add session</b>
      </div>
      <div>
        4. Point the camera to the code on this screen to capture the code
      </div>
    </div>
  </div>
);

const AppLink = () => (
  <a
    target="_blank"
    rel="noreferrer"
    href="https://play.google.com/store/apps/details?id=com.ictlife.africasasa"
  >
    ICTLife User App
  </a>
);
